import { render, staticRenderFns } from "./Jxxz.vue?vue&type=template&id=f78b09ac&scoped=true"
import script from "./Jxxz.vue?vue&type=script&lang=js"
export * from "./Jxxz.vue?vue&type=script&lang=js"
import style0 from "./Jxxz.vue?vue&type=style&index=0&id=f78b09ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78b09ac",
  null
  
)

export default component.exports